import React from "react";
import theme from "./../../Utils/theme"
import { Notification } from "react-admin"

import { ThemeProvider } from '@material-ui/core/styles';

export default function AppProvider(props) {
  return (
    <ThemeProvider theme={theme}><>
      {props.children}
    </>
      <Notification />
    </ThemeProvider>
  );
}

export function AuthenticatedProvider(props) {
  return (
    <ThemeProvider theme={theme}>
      <>
        <Notification />
        {props.children}
      </>
    </ThemeProvider>
  )
}